import { makeApiRequest } from '@/src/lib/api-request'
import { ErrorMessages, ErrorResponse } from '@/src/types/api-error'
import { useMutation } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useRedeemBalanceMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['user', 'redeem'],
    mutationFn: async ({
      coinAmount,
      amountType,
    }: {
      coinAmount: number
      amountType: 'inr' | 'lyk-coin' | 'usd'
    }) => {
      return await makeApiRequest({
        url: '/Earning/redeemRequestGenerate',
        method: 'POST',
        data: {
          coinAmount: coinAmount,
          type: amountType,
        },
        isAuthenticated: true,
        fallbackError: '',
        onError: (e) => {
          if (e instanceof AxiosError) {
            const error = e.response?.data as ErrorResponse
            if (error?.message && error?.message in ErrorMessages) {
              const verificationErrors = ['error/redeem-window-closed']
              if (verificationErrors.includes(error.message)) {
                throw new Error(ErrorMessages[error.message])
              }
              throw new Error(ErrorMessages[error.message])
            }
          }
        },
        isV3Api: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wallet-balance'] })
      queryClient.invalidateQueries({ queryKey: ['breakdown'] })
    },
  })
}
